import React from 'react';
import { reportingCopy } from '../../../copy/advisor-dashboard/advisor-dashboard-base.json';
import BoxWithShadow from '../basic-style-components/BoxWithShadow';

export default function EcapCompletionChartPopover(props) {
  const currentYear = new Date().getFullYear();
  const legendItems = {
    [`Class of ${[currentYear]}`]: {
      color: reportingCopy.ecapCompletions.colorScale[0],
      complete: props.data[`Class of ${[currentYear]}`].complete,
      incomplete: props.data[`Class of ${[currentYear]}`].incomplete,
    },
    [`Class of ${[currentYear + 1]}`]: {
      color: reportingCopy.ecapCompletions.colorScale[1],
      complete: props.data[`Class of ${[currentYear + 1]}`].complete,
      incomplete: props.data[`Class of ${[currentYear + 1]}`].incomplete,
    },
    [`Class of ${[currentYear + 2]}`]: {
      color: reportingCopy.ecapCompletions.colorScale[2],
      complete: props.data[`Class of ${[currentYear + 2]}`].complete,
      incomplete: props.data[`Class of ${[currentYear + 2]}`].incomplete,
    },
    [`Class of ${[currentYear + 3]}`]: {
      color: reportingCopy.ecapCompletions.colorScale[3],
      complete: props.data[`Class of ${[currentYear + 3]}`].complete,
      incomplete: props.data[`Class of ${[currentYear + 3]}`].incomplete,
    },
    [`Class of ${[currentYear + 4]}`]: {
      color: reportingCopy.ecapCompletions.colorScale[4],
      complete: props.data[`Class of ${[currentYear + 4]}`].complete,
      incomplete: props.data[`Class of ${[currentYear + 4]}`].incomplete,
    },
  };

  return (
    <div className="ecap-completion-chart-popover">
      <BoxWithShadow>
        <div className="ecap-completion-chart-popover__color-squares">
          {Object.entries(legendItems).map(([year, details]) => {
            return (
              <div
                className="ecap-completion-chart-popover__color-square"
                style={{ backgroundColor: details.color }}
                key={year}
              />
            );
          })}
        </div>
        <div className="ecap-completion-chart-popover__counts">
          <div className="ecap-completion-chart-popover__counts-incomplete">
            {Object.entries(legendItems).map(([year, details]) => {
              return (
                <div
                  className="ecap-completion-chart-popover__count"
                  key={year}
                >
                  {details.incomplete}
                </div>
              );
            })}
          </div>
          <div className="ecap-completion-chart-popover__counts-complete">
            {Object.entries(legendItems).map(([year, details]) => {
              return (
                <div
                  className="ecap-completion-chart-popover__count"
                  key={year}
                >
                  {details.complete}
                </div>
              );
            })}
          </div>
        </div>
        {/* //{' '}
          <div className="ecap-completion-chart-popover__counts-label ecap-completion-chart-popover__counts-label-complete">
            // {details.complete}
            //{' '}
          </div>
          //{' '}
          <div className="ecap-completion-chart-popover__counts-label ecap-completion-chart-popover__counts-label-incomplete">
            // {details.incomplete}
            //{' '}
          </div>
          //{' '}
        </div>
        // ); // })} */}
      </BoxWithShadow>
    </div>
  );
}
